/**
 * Renders a job's experience range for display. Returns null when the job
 * states no requirement, so the caller drops the whole row rather than
 * showing an empty one.
 *
 * The values arrive as plain JSON numbers — the server's Numeric(4, 1)
 * `3.0` parses to `3` in JS — so no decimal normalizing is needed here.
 *
 *   (null, null) -> null
 *   (5, null)    -> "5+ yrs"
 *   (3, 3)       -> "3 yrs"
 *   (1, 1)       -> "1 yr"
 *   (0, 5)       -> "0–5 yrs"
 */
export function formatExperienceRange(min, max) {
  if (min == null && max == null) return null;
  if (max == null) return `${min}+ yrs`;
  const low = min ?? 0;
  if (low === max) return `${low} ${low === 1 ? "yr" : "yrs"}`;
  return `${low}–${max} yrs`;
}

/**
 * Normalizes a job-experience form field for the API payload. Blank,
 * null, undefined, or non-numeric input becomes null — never a silent 0
 * (a cleared field used to be sent as "0 years required").
 */
export function parseExperienceValue(value) {
  if (value === null || value === undefined) return null;
  const trimmed = typeof value === "string" ? value.trim() : value;
  if (trimmed === "") return null;
  const num = Number(trimmed);
  return Number.isFinite(num) ? num : null;
}
